import { render, staticRenderFns } from "./ExportWord.vue?vue&type=template&id=4642af2e"
import script from "./ExportWord.vue?vue&type=script&lang=js"
export * from "./ExportWord.vue?vue&type=script&lang=js"
import style0 from "./ExportWord.vue?vue&type=style&index=0&id=4642af2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports